import { render, staticRenderFns } from "./Dashboards.vue?vue&type=template&id=f5bbac44&"
import script from "./Dashboards.vue?vue&type=script&lang=js&"
export * from "./Dashboards.vue?vue&type=script&lang=js&"
import style0 from "./Dashboards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports